// extracted by mini-css-extract-plugin
export default {"body":"CrystalCard_body__+g+um","content":"CrystalCard_content__a4kdb","title":"CrystalCard_title__h6S4L","features":"CrystalCard_features__UBvkY","image":"CrystalCard_image__RRRJY"};